import { mapActions } from "vuex";
import moment from "moment";
import statusFilter from '@/components/filter'
import draggable from 'vuedraggable'
import _ from "lodash";
export default {
    name: "orderList",
    components: {
        draggable,
        statusFilter
    },
    data() {
        return {
            permissions: {
				LongOrderList_Export: false,    //导出
                LongOrderList_Query: false,     //查看
                LongOrderList_Cancel: false,    //取消订单
                toBidding: false,               //去招标
                LongOrderList_Look: false       //查询
			},
            srcColumeList:['长期订单号','客户订单号','时间'],
            srcColumeList_checked:['长期订单号','客户订单号','时间'],
            statusObj: { /* 订单详情状态 */
                status: true,
                status1: false,
                status2: false,
                status3: false,
            }, 
            longTab: 'order',
            weekDateList:[{week:'周一',date:'-'},{week:'周二',date:'-'},{week:'周三',date:'-'},{week:'周四',date:'-'},{week:'周五',date:'-'},{week:'周六',date:'-'},{week:'周日',date:'-'},],
            filterList1: [
                { label: "待竞价", value: 501 },
                { label: "竞价中", value: 502 },
                { label: "待确认定标", value: 503 },
            ],
            filterList2: [
                { label: "未指派人车", value: 1 },
                { label: "已指派人车", value: 2 },
            ],
            filterList3: [
                { label: "未确认收货", value: 1 },
                { label: "已确认收货", value: 2 },
            ],
            filterList4: [
                { label: "货主取消", value: 506 },
                { label: "已流标", value: 505 },
            ],
            isDataFromSessionStrorage: false,
            dataOwner: [],
            cancelLoading: false,
            monitors: [],
            etcFenceDistanceMap: {},
            bidContacts: '',
            cdTmIns: null,
            show: {
                OrderList_Export: false,
                OrderList_Cancel: false,
                OrderUpdate: false,
                OrderList_Ensure: false,
            },
            bidDay: 0,
            bidHour: 0,
            bidMinute: 0,
            bidSecond: 0,
            bid_orderId: null,
            bid_batchNo: null,
            isTaskConflict: 0,
            bargainPrice: null,
            expectPrice: null,
            floatingRatio: 0,
            page: 'orderList',
            checkpictureVisible: false,
            configColsVisible: false,/*  自定义页面配置，自定义列 */
            loading: false,
            loading_w: false,
            exportLoading: false,
            vehicleMap: [{
                "plVehicleType": "厢式",
                "plVehicleCode": "300",
                "grdVehicleCode": "002001"
            },
            {
                "plVehicleType": "平板",
                "plVehicleCode": "350",
                "grdVehicleCode": "002007"
            },
            {
                "plVehicleType": "高栏",
                "plVehicleCode": "450",
                "grdVehicleCode": "002024"
            },
            {
                "plVehicleType": "特种运输",
                "plVehicleCode": "600",
                "grdVehicleCode": "002025"
            },
            {
                "plVehicleType": "封闭式一体货车/客车",
                "plVehicleCode": "100",
                "grdVehicleCode": "002016"
            },
            {
                "plVehicleType": "冷藏车",
                "plVehicleCode": "900",
                "grdVehicleCode": "002013"
            }],
            SFMap: window.SFMap,
            mode: '1',
            form: {
                batchNo: null,
                carrierName: null,
                pageNum: 1,
                pageSize: 10,
            },
            form_w: {
                orderManageId: null,
                effectiveTm: [],
                effectiveStart: null,
                effectiveEnd: null,
                planDepartTm: '',
                carrierName: null,
                carrierPhone: null,
                planDepartTmStart: null,
                planDepartTmEnd: null,
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            total_w: 0,
            tabs: {
                activeName: 0,
                label0: '全部',
                label11: '待交易',
                label12: '交易中',
                label13: '服务中',
                label14: '已完成',
                label15: '已中止',
                label16: '已取消',
            },
            // 待竞价，竞价中，待定标，已定标，已流标
            tabItems: [
                { label: '全部', value: 0, id: 0, prop: 'total' },
                { label: '待竞价', value: 0, id: 501, prop: 'bidPreCount' },
                { label: '竞价中', value: 0, id: 502, prop: 'biddingCount' },
                { label: '待确认定标', value: 0, id: 503, prop: 'bidConfirmCount' },
                { label: '已定标', value: 0, id: 504, prop: 'bidEnsureCount' },
                { label: '已流标', value: 0, id: 505, prop: 'bidFailCount' },
                { label: '已取消', value: 0, id: 506, prop: 'bidCancelCount' }
            ],
            table: [],
            // 批次号，订单状态，运输模式，发货地址，收获地址，经停地址，货物信息，车型车长，实际承运商名称，实际承运商联系电话，备注，操作人，操作时间，操作
            columns: [
                { label: '批次号', prop: 'batchNo', width: 180 },
                { label: '订单状态', prop: 'dealStateStr', width: 100 },
                { label: '运输模式', prop: 'transportModeStr', width: 100, formatter:(row)=>{
                   return  row.detailList.map(item => {
                      return <div class='cell-sublist' title={item.transportModeStr}>{item.transportModeStr}</div>
                    })
                }},
                { label: '发货地址', prop: 'srcAddr', width: 260, formatter:(row)=>{
                    return  row.detailList.map(item => {
                       return <div class='cell-sublist' title={item.srcAddr}>{item.srcAddr}</div>
                     })
                 } },
                { label: '收货地址', prop: 'destAddr', width: 260, formatter:(row)=>{
                    return  row.detailList.map(item => {
                       return <div class='cell-sublist' title={item.destAddr}>{item.destAddr}</div>
                     })
                 } },
                { label: '货物信息', prop: 'cargoInfo', width: 200, formatter:(row)=>{
                    return row.cargoType + '/' +row.cargoVolume+ '/' +  row.cargoWeight
                } },
                { label: '车型车长', prop: 'vehicleTypeStr', width: 130 },
                { label: '实际承运商名称', prop: 'carrierName', width: 150 },
                { label: '实际承运商联系电话', prop: 'carrierPhone', width: 150 },
                { label: '备注', prop: 'comment', width: 200, formatter:(row)=>{
                    return  row.detailList.map(item => {
                       return <div class='cell-sublist' title={item.comment}>{item.comment}</div>
                     })
                 } },
                { label: '操作人', prop: 'creator', width: 100 },
                { label: '操作时间', prop: 'createTm', width: 100, formatter:(row)=>{
                    return moment(new Date(row.createTm)).format('YYYY-MM-DD') 
                } },
            ],
            table_w: [],
            detail: {
                map: {
                    carNewestPosMarker: null,
                    mapIns: '',
                    polyline: '',
                    pointLayer: null,
                    planLayer: [],
                    carLayer: [],
                    phoneLayer: [],
                    truckMainCoordinate: [],
                    planGPS: false,
                    carGPS: false,
                    phoneGPS: false,
                    coordinates: [],
                    planCoordinates: [],
                    carCoordinates: [],
                    phoneCoordinates: [],
                },
                order: {
                    title: '-'
                    , state: ''
                    , statusName: '待交易'
                    , orderId: ''
                    , planArriveTm: ''
                    , reachTm: ''
                    , totalPrice: ''
                    , needReceipt: ''
                    , needReceiptImg: ''
                    , needReceiptSrc: ''
                    , dataOwner: ''
                    , distance: ''
                    , runTm: ''
                    , cargoInfo: ''
                    , cargoWeight: ''
                    , cargoVolume: ''
                    , mode: ''
                    , carType: ''
                    , vehicleType: ''
                    , vehicleLength: ''
                    , comment: ''
                    , priceRule: ''
                    , price: ''
                    , passZones: []
                    , oplogList: []
                    , srcCity: ''
                    , vehicleSerial: ''
                    , taskId: ''
                    , biddingVO: {
                        biddingEndTm: null,
                        biddingStartTm: null,
                        dealState: null,
                        enterUserCount: null,
                        expectPrice: null,
                        floatPercentage: null,
                        joinUserCount: null,
                        lowestPrice: null,
                        totalPrice: null,
                    }
                    , deductionInfoResponses: []
                },
                table: [],
                logData: [],
            },
            orderDetailVisible: false,
            orderDetailLoading: false,
            cancelVisible: false,
            isKeyDate: false,
            bidVisible: false,
            progress: 0,
            cancelForm: {
                // rules: {
                //     deleteReason: [{ required: true, message: "请选择取消原因", trigger: "change" }],
                // },
                // orderId: '',
                // deleteReason: '',
                // deleteReasonDesc: '',
                // opDate: '',
                model: {
                    reason: '',
                    batchNo:[],
                    isLongOrder: true
                },
                rules:{
                    reason: [{ required: true, message: "请选择取消原因", trigger: "change" }],
                }
            },
            pickerOptions:{
                disabledDate(time){
                    return time.getTime() < Date.now() - 8.64e7 //可选择今天
                }
            },
            canTitle: '取消订单'
        }
    },
    filters: {
        statusFormat(statu) {
            switch(statu) {
                case '0':
                case 0:
                    return '流程中';
                    break;
                case '1':
                case 1:
                    return '生效';
                    break;
                case '2':
                case 2:
                    return '失效';
                    break;
                default:
                    return statu;
                    break;
            }
        }
    },
    methods: {
        ...mapActions([
            'getPlanOrderListApiLong',
            'getPlanOrderList_wApi',
            'planOrderExportApiLong',
            'getPlanOrderDetailApiLong',
            'relPlanOrderApi',/* 临时用车关联订单 */
            'getPlanOrderStatApi',
            'cancelPlanOrderApiLong',
            'stoplPlanOrderNewApi',
            'cancelOrderApi',
            'ensureOrderApi',
            'queryReceiptApi',
            'queryTrackApi',
            'queryBidDetailApiLong',
            'confirmBidApiLong',
            'initPlaceApi',
            'getStopHandleOrderByIdApi'
        ]),
        /* 自定义列 */
        syncColume(){

        },
        /* 周排班状态 0无1未开始2进行中3已完成4已取消5已终止 */
        geneColumnImg(status){
            let html = '';
            let icon = ''
            if(status==1){
                icon = 'undo'
            }else if(status==2){
                icon = 'ing'
            }else if(status==3){
                icon = 'finish'
            }else if(status==4){
                icon = 'cancel'
            }else if(status==5){
                icon = 'zz'
            }else{
                icon = ''
            }
            html = `<span class="commonicon ${icon}"></span>`
            return html ;
        },
        geneColumn(row,idx){
            let key = null
            switch(idx){
                case 0: key = 'monday';break;
                case 1: key = 'tuesday';break;
                case 2: key = 'wednesday';break;
                case 3: key = 'thursday';break;
                case 4: key = 'friday';break;
                case 5: key = 'saturday';break;
                case 6: key = 'weekday';break;
            }
            return this.geneColumnImg(row[key].task)
        },
        onWeek(index){
            let f = 'YYYY-MM-DD'
            let m = null
            let val = null
            if(index==-1){
                let start = this.form_w.planDepartTmStart
                m = moment(start).subtract(6, 'days')
            }else if(index==1){
                let end = this.form_w.planDepartTmEnd
                m = moment(end).add(2, 'days')
            }
            val = m.format(f)
            this.changeDate(val)
            this.$nextTick(function(){
                this.form_w.planDepartTm = m._d
                this.getOrderList_w();
            })
        },
        changeDate(val) {
            let f = 'YYYY-MM-DD'
            let d = moment(val).format(f)
            this.form_w.planDepartTmStart = moment(d).subtract(1, 'days').format(f)
            this.form_w.planDepartTmEnd = moment(d).add(5, 'days').format(f)
        },
        longtabClick() { },
        resetSubStatus() { /* 重置子状态 */
            this.form.dealState = ''
            // this.form.assignState = ''
            // this.form.ensureState = ''
        },
        onSelectSubStatus(emitObj, formItem, indx) {
            this.tabs.activeName = indx
            this.resetSubStatus();
            this.form[formItem] = emitObj.value
            this.getOrderList()
        },
        mapFindCar(dispatchMode) {
            let res = '';
            switch (dispatchMode) {
                case 0: res = '指派用车'; break;
                case 1: res = '一口价找车'; break;
                case 2: res = '竞价找车'; break;
                default: res = ''; break;
            }
            return res;
        },
        calcCDTime() {
            let a = moment()
            let b = moment(this.detail.order.biddingVO.end)
            let m = b.diff(a, 'seconds')
            if (this.cdTmIns) {
                clearInterval(this.cdTmIns)
                this.bidDay = 0
                this.bidHour = 0
                this.bidMinute = 0
                this.bidSecond = 0
            }
            if (m > 0) {

                this.cdTmIns = setInterval(() => {
                    let days = moment.duration(m, 'seconds').days()
                    let hours = moment.duration(m, 'seconds').hours()
                    let minutes = moment.duration(m, 'seconds').minutes()
                    let seconds = moment.duration(m, 'seconds').seconds()

                    if (hours < 10) {
                        hours = '0' + hours
                    }
                    if (minutes < 10) {
                        minutes = '0' + minutes
                    }
                    if (m == 0 || m < 0) {
                        clearInterval(this.cdTmIns)
                    }
                    this.bidDay = days
                    this.bidHour = hours
                    this.bidMinute = minutes
                    this.bidSecond = seconds
                    m--;
                }, 1000);
            } else {

            }
        },
        mapCreateType(type) {
            let createType = ''
            switch (type) {
                case "1": createType = '系统创建'; break;
                case "2": createType = '人工创建'; break;
                default: createType = '-'; break;
            }
            return createType
        },
        onHandBid(action) {
            this.confirmBidApiLong({ batchNo: this.bid_batchNo, operate: action }, true).then(res => {
                this.bidVisible = false
                if (action == 1) {
                    this.$message({
                        type: 'success',
                        message: '定标成功'
                    });
                } else {
                    this.$message({
                        type: 'success',
                        message: '已流标'
                    });
                }
                this.getOrderList();
            })
        },
        onConfirmBid(row) {
            this.queryBidDetailApiLong({ batchNo: row.batchNo }, true).then(res => {
                this.bid_orderId = row.orderId
                this.bid_batchNo = row.batchNo
                this.bidVisible = true
                this.bargainPrice = res.bargainPrice
                this.expectPrice = res.expectPrice
                this.floatingRatio = res.floatingRatio
                this.bidContacts = res.carrierName
                // this.isTaskConflict = res.isTaskConflict
                // if (res.carriageType == 1) {
                //     this.bidContacts = res.driverName + ' / ' + res.driverPhone
                // } else {
                //     this.bidContacts = res.carrierName

                // }
            })
        },
        onAlterOrder(orderId) {
            sessionStorage.setItem('alterOrderId', orderId)
            this.$router.push('/manage/Shipments')
        },
        geneDetails(row) {
            let desc = row.desc ? row.desc : '-'
            let comment = row.comment ? row.comment : '-'
            let emtpy = "&nbsp;&nbsp;&nbsp;"
            return desc + emtpy + comment
        },

        onCheckPicture() {
            if (this.detail.order.needReceiptSrc) {
                this.checkpictureVisible = true;
            }
        },
        queryReceipt() {
            let params = {
                orderId: this.detail.order.orderId,
                srcCity: this.detail.order.srcCity
            }
            this.queryReceiptApi(params).then(res => {
                let photo = res.photoPath
                if (photo) {
                    this.detail.order.needReceiptImg = '<img title="点击放大" src="' + photo + '">'
                    this.detail.order.needReceiptSrc = photo
                } else {
                    this.detail.order.needReceiptImg = '-'
                }

            }).catch(e => { })
        },
        addhtml(key, value) {
            if (null == value) {
                return "<p>" + key + "</p>";
            } else {
                return "<p>" + key + "<span>" + value + "</span></p>";
            }
        },
        tmFormat(v) {
            if (v) {
                return moment(new Date(v)).format("MM/DD HH:mm");
            }
            return '';
        },
        //始发点弹出提示
        startHtml(monitor, lnglat, etcfenceDistance) {
            if (monitor) {
                let starthtml = "<div class='mapPopupContent' >";
                starthtml += this.addhtml("计划靠车时间：", this.tmFormat(monitor.planReachTm));
                starthtml += this.addhtml("实际靠车时间：", this.tmFormat(monitor.actualSrcGisInTm));
                starthtml += this.addhtml("计划发出时间：", this.tmFormat(monitor.planDepartTm));
                starthtml += this.addhtml("实际发车时间：", this.tmFormat(monitor.actualDepartTm));
                starthtml += this.addhtml("电子围栏半径：", etcfenceDistance);
                starthtml += this.addhtml("经纬度：", lnglat);
                starthtml += "</div>";
                return starthtml;
            }
            return "";
        },
        //经停点 和 终点 弹出提示
        otherHtml(monitor, lnglat, etcfenceDistance) {
            if (monitor) {
                let starthtml = "<div class='mapPopupContent2' >";
                starthtml += this.addhtml("预计到车时间：", this.tmFormat(monitor.preArriveTm));
                starthtml += this.addhtml("计划到车时间：", this.tmFormat(monitor.planArriveTm));
                starthtml += this.addhtml("实际到车时间：", this.tmFormat(monitor.actualArriveTm));
                starthtml += this.addhtml("电子围栏半径：", etcfenceDistance);
                starthtml += this.addhtml("经纬度：", lnglat);
                starthtml += "</div>";
                return starthtml;
            }
            return "";
        },
        //地图弹出提示
        promptMap(map, startMarker, endMarker, startLongitude, endLongitude, vectorLayer, passMarker, passCoordinate) {
            //起点提示
            this.addInfoToMarker(startMarker, startLongitude, this.startHtml(this.monitors[0], startLongitude, this.etcFenceDistanceMap.src));
            //终点提示
            this.addInfoToMarker(endMarker, endLongitude, this.otherHtml(this.monitors[this.monitors.length - 1], endLongitude, this.etcFenceDistanceMap.dest));
            //经停点
            try {
                let passZoneDatas = JSON.parse(JSON.stringify(this.monitors.splice(1, this.monitors.length - 2)));
                if (passMarker.length > 0) {
                    for (let int = 0; int < passMarker.length; int++) {
                        let marker = passMarker[int];
                        let coor = passCoordinate[int];
                        let lnglat = [coor[0], coor[1]];
                        this.addInfoToMarker(marker, lnglat, this.otherHtml(passZoneDatas[int], lnglat, this.etcFenceDistanceMap[coor[0] + coor[1]]));
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },
        //绑定弹出事件
        addInfoToMarker(marker, lnglat, info) {
            let that = this;
            let popup = this.SFMap.popup();
            marker.on("click", function () {
                popup.setLatLng(lnglat).setContent(info).openOn(that.detail.map.mapIns);
            });
        },
        queryTrack() {
            this.monitors = [];
            this.etcFenceDistanceMap = {};
            let params = {
                taskId: this.detail.order.taskId,
                vehicleSerial: this.detail.order.vehicleSerial,
                trucksOnly: 1
            }
            this.queryTrackApi(params).then(res => {
                this.monitors = res.monitors;
                this.etcFenceDistanceMap = JSON.parse(res.etcFenceDistanceMap);
                //车辆实时位置显示
                this.carPosShow(this.latlngSingleConvert(JSON.parse(res.carNewestPos)), false);
                //规划GPS
                let newarr0 = []
                if (res.mainCoordinate) {
                    let arr0 = JSON.parse(res.mainCoordinate)
                    arr0.forEach(item => {
                        newarr0.push([item[1], item[0]])
                    })
                }
                //车载GPS
                let newarr1 = []
                if (res.carLatLng && res.carLatLng.result) {
                    let arr1 = JSON.parse(res.carLatLng.result)
                    arr1.forEach(item => {
                        newarr1.push([Number(parseFloat(item.zy).toFixed(6)), Number(parseFloat(item.zx).toFixed(6))])
                    })
                }
                //手机GPS
                let newarr2 = []
                if (res.phoneLatLng && res.phoneLatLng.result) {
                    let arr2 = JSON.parse(res.phoneLatLng.result)
                    arr2.forEach(item => {
                        newarr2.push([Number(parseFloat(item.zy).toFixed(6)), Number(parseFloat(item.zx).toFixed(6))])
                    })
                }
                this.detail.map.planCoordinates = newarr0
                this.detail.map.carCoordinates = newarr1
                this.detail.map.phoneCoordinates = newarr2
                this.planChange(true);
                this.carChange(true);
                this.phoneChange(true);

                //经过点显示
                let passPoint = res.passCoordinateList
                if (passPoint.length > 0) {
                    passPoint.forEach(item => {
                        item.reverse()
                    })
                    this.drawPoints(passPoint);
                }

            }).catch(e => { })
        },
        onProgessChange(val) {
            let arr = this.detail.map.phoneCoordinates
            let i = parseInt(arr.length * val / 100)
            if (arr.length > 0) {
                this.showSlidePosition(arr[i]);
            }
        },
        showSlidePosition(coordinate) {
            let myIcon = this.SFMap.circleIcon({
                iconRadius: 100,
                backgroundColor: '#FF0033',
                circleRadius: 10,
                boxShadow: '0 0 30px 5px #FF0033',
                ripple: 2,
                rippleColor: '#FF0033',
            });
            let iconMarker = this.SFMap.marker(coordinate, {
                icon: myIcon
            });
            if (this.detail.map.vectorLayer) {
                this.detail.map.vectorLayer.clear();
            }
            this.detail.map.vectorLayer.addLayer(iconMarker);
        },
        mapVehicle(code) {
            let name = ''
            this.vehicleMap.forEach(item => {
                code == item.plVehicleCode && (name = item.plVehicleType)
            })
            return name
        },
        geneTmStr(m) {
            let days = moment.duration(m, 'minutes').days()
            let hours = moment.duration(m, 'minutes').hours()
            let minutes = moment.duration(m, 'minutes').minutes()
            return (days ? days : '-') + '天' + (hours ? hours : '-') + '时' + (minutes ? minutes : '-') + '分'
        },
        mapState(state) {
            let stateName = ''
            switch (state) {
                case 0: stateName = '全部'; break;
                case 11: stateName = '待交易'; break;
                case 12: stateName = '交易中'; break;
                case 13: stateName = '服务中'; break;
                case 14: stateName = '已完成'; break;
                case 15: stateName = '已中止'; break;
                case 16: stateName = '已取消'; break;
                default: stateName = '-'; break;
            }
            return stateName
        },
        clear(layer) {
            if (layer.length > 0) {
                layer[0].remove()
            }
        },
        planChange(val) {
            if (val) {
                this.clear(this.detail.map.planLayer)
                if (this.detail.map.planCoordinates.length > 0) {
                    this.draw(this.detail.map.planCoordinates, this.detail.map.planLayer, '#00bcd4', 10)
                }
            } else {
                this.clear(this.detail.map.planLayer)
            }
        },
        carChange(val) {
            if (val) {
                this.clear(this.detail.map.carLayer)
                if (this.detail.map.carCoordinates.length > 0) {
                    this.draw(this.detail.map.carCoordinates, this.detail.map.carLayer, '#1919fe')
                }
            } else {
                this.clear(this.detail.map.carLayer)
            }
        },
        phoneChange(val) {
            if (val) {
                this.clear(this.detail.map.phoneLayer)
                if (this.detail.map.phoneCoordinates.length > 0) {
                    this.draw(this.detail.map.phoneCoordinates, this.detail.map.phoneLayer, '#DC1E32', 7)
                }
            } else {
                this.clear(this.detail.map.phoneLayer)
            }
        },
        showStatus(status){
            this.statusObj.status1 = false
            this.statusObj.status2 = false
            this.statusObj.status3 = false
            /* 黑色status2  灰色status 红色status11 绿色status3    */
            if(status==12){
                this.statusObj.status2 = true
            }else if(status==13){
                this.statusObj.status3 = true
            }else if(status==14){
                this.statusObj.status3 = true
            }else if(status==15){
                this.statusObj.status3 = true
            }else if(status==16){
                this.statusObj.status2 = true
            }
        },
        onCheckDetail(row) {
            let params = {
                batchNo: row.batchNo
            }
            this.orderDetailVisible = true;
            this.orderDetailLoading = true
            this.getPlanOrderDetailApiLong(params, true).then(result => {
                this.orderDetailVisible = true;
                this.detail.order = result
                this.detail.order.statusName = result.dealState
                this.showStatus(result.dealState)
               /*  let obj = this.detail.order
                obj.orderId = res.orderId
                obj.needReceipt = res.needReceipt
                obj.planArriveTm = res.planArriveTm
                obj.reachTm = res.reachTm
                obj.totalPrice = res.totalPrice
                obj.needReceipt = res.needReceipt
                obj.dataOwner = res.dataOwner
                obj.distance = res.distance
                obj.runTm = res.runTm
                obj.cargoInfo = res.cargoInfo
                obj.cargoWeight = res.cargoWeight
                obj.cargoVolume = res.cargoVolume
                obj.mode = res.mode
                obj.carType = res.carType
                obj.vehicleType = res.vehicleType
                obj.vehicleLength = res.vehicleLength
                obj.comment = res.comment
                obj.priceRule = res.priceRule
                obj.price = res.price
                obj.passZones = res.passZones
                obj.opLogs = res.opLogs
                obj.srcCity = res.srcCity
                obj.vehicleSerial = res.vehicleSerial
                obj.carrierType = (res.carrierType == '1' ? '个人' : res.carrierType == '2' ? (res.childCarrierName ? res.childCarrierName : '') : '-')
                obj.driver = (res.driverName ? res.driverName : '') + ' ' + (res.driverPhone ? res.driverPhone : '')
                obj.taskId = res.taskId
                obj.statusName = this.mapState(res.orderState)
                obj.state = res.orderState
                obj.deductionInfoResponses = res.deductionInfoResponses
                obj.outerOrderId = res.outerOrderId
                obj.quantity = res.quantity
                obj.biddingVO = res.biddingVO
                obj.dispatchMode = res.dispatchMode
                if (res.dispatchMode == 2) {
                    obj.biddingVO.start = moment(res.biddingVO.biddingStartTm).format('YYYY-MM-DD HH:mm')
                    obj.biddingVO.end = moment(res.biddingVO.biddingEndTm).format('YYYY-MM-DD HH:mm')

                }
                obj.status.status1 = false
                obj.status.status2 = false
                obj.status.status3 = false
                if (res.orderState == '1') {
                    if (res.dispatchMode == 2) {
                        if (res.biddingVO.dealState == 501) {
                        } else if (res.biddingVO.dealState == 502 || res.biddingVO.dealState == 503) {
                            obj.status.status1 = true
                            if (res.biddingVO.dealState == 502) {
                                this.calcCDTime()
                            }
                        } else if (res.biddingVO.dealState == 504) {
                            obj.status.status3 = true
                            let vo = obj.biddingVO
                            if (vo.floatPercentage) {
                                vo.floatPercentage = (vo.floatPercentage.indexOf('-') > -1 ? vo.floatPercentage : ('+' + vo.floatPercentage))
                            }
                        } else {
                            obj.status.status2 = true
                        }
                        obj.statusName = this.mapState(res.biddingVO.dealState)
                    }
                } else if (res.orderState == '2') {
                } else if (res.orderState == '3' || res.orderState == '4') {
                    obj.status.status1 = true
                } else {
                    obj.status.status2 = true
                }

                this.orderDetailVisible = true;

                if (res.needReceipt == '1') {
                    this.queryReceipt();
                }

                let tplState = res.orderState;
                if (tplState == '3' || tplState == '4' || tplState == '9' || tplState == '10') {
                    this.onToggleMode()
                } */
            }).finally(() => {
                this.orderDetailLoading = false
            });
        },
        eCloseCancel() {
            this.$refs.cancelFormRef.resetFields();
        },
        onCancelOrder(row) {
            this.canTitle = "取消订单"
            this.cancelForm.model.batchNo = row.batchNo
            this.cancelVisible = true;
        },
        onZzOrder(row) { /* 中止订单 */
            this.canTitle = "中止订单"
            this.cancelForm.orderManageId = row.orderManageId
            this.cancelVisible = true
            this.isKeyDate = row.status === 13?true:false
            if(this.isKeyDate){
                this.cancelForm.rules.opDate=[{ required: true, message: "请选择终止日期", trigger: "change" }]
            }
        },
        onGoOrder(row) {  //去招标
            this.$router.push('/manage/saasLineManage');
        },
        onCancelConfirm() {
            // let params = {
            //     orderManageId: this.cancelForm.orderManageId,
            //     remark: this.cancelForm.deleteReason + (this.cancelForm.deleteReasonDesc?(','+this.cancelForm.deleteReasonDesc):''),
            // }
            // this.isKeyDate?params.opDate = this.cancelForm.opDate:""
            // if(this.isKeyDate) {
            //     this.$refs.cancelFormRef.validate((valid) => {
            //         if (valid) {
            //             this.cancelLoading = true
            //             if(this.isKeyDate){
            //                 this.stoplPlanOrderNewApi(params).then(res => {
            //                     this.$message({
            //                         type: 'success',
            //                         message: '中止成功'
            //                     });
            //                     this.cancelVisible = false
            //                     this.getOrderList();
            //                 }).catch(e => { }).finally(() => { this.cancelLoading = false });
            //             }else{}
                
            //         }
            //     })
            // }else{
            //     this.$refs.cancelFormRef.validate((valid) => {
            //         if (valid) {
            //             this.cancelLoading = true
            //             this.cancelPlanOrderApiLong(params).then(res => {
            //                 this.$message({
            //                     type: 'success',
            //                     message: '取消成功'
            //                 });
            //                 this.cancelVisible = false
            //                 this.getOrderList();
            //             }).catch(e => { }).finally(() => { this.cancelLoading = false });
            //         }
            //     })
            // }
            this.$refs.cancelFormRef.validate((valid) => {
                if (valid){
                    this.cancelLoading = true
                    this.cancelPlanOrderApiLong(this.cancelForm.model, true).then(res => {
                        this.$message.success('操作成功')
                        this.cancelVisible = false
                        this.getOrderList()
                    }).catch(e=>{
                        this.$message.error(e.msg || '操作失败')
                    }).finally(() => {
                        this.cancelLoading = false
                    })
                }
            })
        },
        onAcceptOrder(row) {
            let params = {
                orderId: row.orderId
                , shippingState: 2
            }
            this.$confirm(`确定收货？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.ensureOrderApi(params).then(res => {
                    this.$message({
                        type: 'success',
                        message: '收货成功'
                    });
                    this.getOrderList();
                }).catch(e => { });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "取消确认",
                });
            });
        },
        //显示当前车辆位置
        carPosShow(carNewestPosMap, isRequest) {
            if (this.detail.map.carNewestPosMarker) {
                this.detail.map.vectorLayer2.removeLayer(this.detail.map.carNewestPosMarker);
            }
            if (carNewestPosMap && carNewestPosMap.length > 0) {
                // 自定义图片图标
                let myIcon = this.SFMap.icon({
                    iconUrl: document.querySelector("#vehicleCurrentPosImg").src, // 图片路径
                    iconSize: [30, 30]
                });
                this.detail.map.carNewestPosMarker = this.SFMap.marker(carNewestPosMap, {
                    icon: myIcon
                });
                this.detail.map.vectorLayer2.addLayer(this.detail.map.carNewestPosMarker);
            }
        },
        latlngSingleConvert(latlng) {
            let latlngArray = []
            if (!latlng) {
                return latlngArray;
            }
            let zx = parseFloat(latlng[0]);
            let zy = parseFloat(latlng[1]);
            if (0.0 == zx && 0.0 == zy) {
                return latlngArray;
            }
            latlngArray.push(zy);
            latlngArray.push(zx);
            return latlngArray;
        },
        drawPoints(coordinates) {
            if (this.detail.map.pointLayer) {
                this.detail.map.pointLayer.clearLayers()
            }
            let startMarker = this.SFMap.marker(coordinates[0], { iconIndex: 'start' });
            let endMarker = this.SFMap.marker(coordinates[coordinates.length - 1], { iconIndex: 'end' });
            let passMarker = [];
            let pCoordinate = [];
            for (let i = 1; i < coordinates.length - 1; i++) {
                passMarker.push(this.SFMap.marker(coordinates[i], { iconIndex: 'pass' }));
                pCoordinate.push(coordinates[i]);
            }
            this.detail.map.pointLayer = this.SFMap.vectorLayer({ map: this.detail.map.mapIns, features: [startMarker, ...passMarker, endMarker] });
            //弹出提示事件
            if (this.monitors.length >= 2) {
                this.promptMap(this.detail.map.mapIns, startMarker, endMarker, coordinates[0], coordinates[coordinates.length - 1], this.detail.map.vectorLayer, passMarker, pCoordinate);
            }
        },
        draw(coordinates, layer, color, width) {
            let c = color ? color : "#3388ff"
            let tplLayer = this.SFMap.polyline(coordinates, {
                map: this.detail.map.mapIns,
                color: c,
                opacity: 1,
                weight: (width ? width : 3),
                showSymbol: true,
                symbol: [{
                    type: 'arrow',
                    repeat: 50,
                    offset: 15,
                    rotate: false,
                    color: '#ffffff',
                    symbol: undefined
                }]
            });
            layer[0] = tplLayer
            this.detail.map.mapIns.fitBounds(tplLayer.getBounds());
        },

        eOpenDetail() {

        },
        initMap() {
            if (!this.detail.map.mapIns) {
                this.detail.map.mapIns = this.SFMap.map("map", {
                    center: [22.524729, 113.940159],
                    zoom: 12
                });
                this.detail.map.vectorLayer = this.SFMap.vectorLayer({ map: this.detail.map.mapIns });
                this.detail.map.vectorLayer2 = this.SFMap.vectorLayer({ map: this.detail.map.mapIns });

            }
        },
        getComParams() {
            let params = Object.assign({}, this.form)
            // if (params.effectiveTm && params.effectiveTm.length > 0) {
            //     params.effectiveStart = params.effectiveTm[0] + ' 00:00:00'
            //     params.effectiveEnd = params.effectiveTm[1] + ' 23:59:59'
            // }
            params.dealState = this.tabs.activeName == 0 ? null : this.tabs.activeName;
            // delete params.effectiveTm
            return params
        },
        getOrderList() {
            this.table = []
            this.loading = true
            let params = this.getComParams();
            this.getPlanOrderListApiLong(params, true).then(res => {
                this.table = res.rows || []
                this.total = res.totalCount || 0
            }).catch(e => { }).finally(() => {
                this.loading = false
            });
            this.getPlanOrderStatApi(params).then(res => {
                this.tabItems.forEach(item => {
                    item.value = res[item.prop] || 0
                })
            })
        },
        getOrderListMocker(n){
            const rows = []
            for(let i = 0;i < n; i++){
                const row = {}
                this.columns.forEach((item,index)=>{
                    row[item.prop] = this.generateRandomString(8)
                })
                rows.push(row)
            }
            return rows
        },
        generateRandomString(length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
              result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
          },
        getOrderList_w() {
            let params = Object.assign({}, this.form_w)
            this.table_w = []
            this.loading_w = true
            if (params.effectiveTm && params.effectiveTm.length > 0) {
                 params.effectiveStart = params.effectiveTm[0] + ' 00:00:00'
                 params.effectiveEnd = params.effectiveTm[1] + ' 23:59:59'
             } 
            this.generateTableHeader()
            this.getPlanOrderList_wApi(params).then(res => {
                this.table_w = res.rows;
                this.total_w = res.totalCount
                this.weekDateList[0].week = '周一 '
            }).catch(e => { }).finally(() => {
                this.loading_w = false
            });
        },
        generateTableHeader(){
            let first = this.form_w.planDepartTmStart
            this.weekDateList = [];
            for(let i = 1;i<8;i++){
                let week = null;
                let date = null;
                switch(i){
                    case 1: week = '周一'; date = moment(first).format('MM-DD');break;
                    case 2: week = '周二'; date = moment(first).add(1,'days').format('MM-DD');break;
                    case 3: week = '周三'; date = moment(first).add(2,'days').format('MM-DD');break;
                    case 4: week = '周四'; date = moment(first).add(3,'days').format('MM-DD');break;
                    case 5: week = '周五'; date = moment(first).add(4,'days').format('MM-DD');break;
                    case 6: week = '周六'; date = moment(first).add(5,'days').format('MM-DD');break;
                    case 7: week = '周日'; date = moment(first).add(6,'days').format('MM-DD');break;
                }
                this.weekDateList.push({week,date})
            }
        },
        onExport() {
            this.exportLoading = true
            let params = this.getComParams();
            this.planOrderExportApiLong(params, true).then(res => {
                window.open(this.getHostUrl() + "/saas/orderCore/downLoadFile?objectName=" + res.filePath)
            }).catch(e => { }).finally(() => {
                this.exportLoading = false
            });
        },
        getHostUrl() {
            return location.protocol + "//" + location.host;
        },
        showDownload(url) {
            let downloadbtn = `<a href="${url}">点击下载导出的Excel文件</a>`
            this.$alert(downloadbtn, '下载', {
                confirmButtonText: '取消',
                customClass: 'css-alert',
                dangerouslyUseHTMLString: true,
                callback: action => { }
            });
        },
        onReset() {
            Object.assign(this.form, this.$options.data().form)
        },
        onReset_w() {
            Object.assign(this.form_w, this.$options.data().form_w)
            // 解决点击周排版tab页中重置按钮，上一周和下一周日期清空后台接口报错问题
            let week_feb = moment().day(2).format('YYYY-MM-DD')
            this.changeDate(week_feb)
            this.$nextTick(function(){
                this.form_w.planDepartTm = '2021-03-10'
            })
        },
        lineList(row) {
            return '<span class="point src"></span>' + row.srcAddr + '<br><span class="point dest"></span>' + row.destAddr
        },
        onSearch() {
            this.getOrderList();
        },
        onSearch_w() {
            this.getOrderList_w();
        },
        onTabsClick(item) {
            this.resetSubStatus();
            // this.tabs.activeName = activeIndex
            this.tabs.activeName = item.id
            this.form.pageNum = 1;
            this.getOrderList()
        },
        onSizeChange() { },
        onCurrentChange(val) {
            this.form.pageNum = val;
            this.getOrderList()
        },
        onCurrentChange_w(val) {
            this.form_w.pageNum = val;
            this.getOrderList_w()
        },
        initMapData() {
            this.detail.map.phoneGPS = true;
            this.detail.map.carGPS = true;
            this.detail.map.planGPS = true;
            this.progress = 0;
            if (this.detail.map.phoneLayer.length > 0) {
                this.clear(this.detail.map.phoneLayer)
            }
            if (this.detail.map.carLayer.length > 0) {
                this.clear(this.detail.map.carLayer)
            }
            if (this.detail.map.planLayer.length > 0) {
                this.clear(this.detail.map.planLayer)
            }
            if (this.detail.map.pointLayer) {
                this.detail.map.pointLayer.clearLayers()
            }

        },
        onToggleMode() {
            if (this.mode == '1') {
                this.mode = '2'
                this.initMapData();
                this.queryTrack();
                setTimeout(() => {
                    this.initMap()
                }, 0)
            } else {
                this.mode = '1'
            }
        },
        getParamsFromSession() {
            let params = JSON.parse(sessionStorage.getItem('orderListQueryParams'))
            if (params) {
                Object.assign(this.form, params) /* 回填切换tab保留查询条件 */
                this.isDataFromSessionStrorage = true
            }
        },
        formatTm(v) {
			if (v) {
				return moment(new Date(v)).format("YYYY-MM-DD HH:mm:ss");
			}
			return null;
		},
        // 点击表格右侧中止图标等(现在只对中止按钮作响应)
        dealWith(mrow,idx) {
            let key = null;
            switch(idx){
                case 0: key = 'monday';break;
                case 1: key = 'tuesday';break;
                case 2: key = 'wednesday';break;
                case 3: key = 'thursday';break;
                case 4: key = 'friday';break;
                case 5: key = 'saturday';break;
                case 6: key = 'weekday';break;
            }
            if(mrow[key].task == 5) {
                let params = {};
			    params.orderManageId = mrow.orderManageId;
                params.orderId = mrow[key].orderId;
                this.getStopHandleOrderByIdApi(params).then(res => {
                    // if(res.status!=0 && res.status!=3){
                    //     that.$message({
                    //         type: "error",
                    //         message: '该订单状态为已处理或已取消,不允许发货'
                    //     });
                    //     return;
                    // }
                    let row = {};
                    row.dataOwner = res.dataOwner;
                    row.orderManageId = mrow.orderManageId;
                    row.orderId = mrow[key].orderId;
                    row.cargoVolume = res.cargoVolume;
                    row.cargoInfo = res.cargoType;
                    row.cargoWeight = res.cargoWeight;
                    row.quantity = res.cargoNum;
                    row.outerOrderId = res.outerOrderId;
                    row.totalLineDistance = res.lineDistance;
                    row.comment = res.comment;
                    row.vehicleType = res.vehicleType;
                    row.vehicleLength = res.vehicleLength+'';
                    row.expectedPrice = res.expectedPrice;
                    //不需要回单
                    if (res.needReceipt == 2) {
                        row.needReceipt = 1;
                    } else {
                        row.receiptType = res.receiptType;
                        // 电子回单
                        if (row.receiptType == 1) {
                            row.needReceipt = 2;
                        }
                        // 电子+纸质回单
                        if (row.receiptType == 2) {
                            row.needReceipt = 3;
                            row.receiptAddress = res.receiptAddress;
                            row.receiptName = res.receiptName;
                            row.receiptPhone = res.receiptPhone;
                        }
                    }
                    let start = res.passZoneResponseList[0];
                    let end = res.passZoneResponseList[res.passZoneResponseList.length-1];
                    row.start={
                        addrDetail:start.addrDetail,
                        orderPlacerName:start.contactName,
                        planArriveTm:this.formatTm(start.planArriveTm),
                        orderPlacerPhone:start.contactPhone,
                        planSendtm:this.formatTm(start.planDepartTm),
                        sortNum:start.sortNum,
                        jobType:start.jobType,
                        coordinate:start.coordinate,
                        cityCode:start.cityCode,
                        cityName:start.cityName
                    };
                    row.end={
                        addrDetail:end.addrDetail,
                        orderPlacerName:end.contactName,
                        planArriveTm:this.formatTm(end.planArriveTm),
                        orderPlacerPhone:end.contactPhone,
                        planSendtm:this.formatTm(end.planDepartTm),
                        sortNum:end.sortNum,
                        jobType:end.jobType,
                        coordinate:end.coordinate,
                        cityCode:end.cityCode,
                        cityName:end.cityName
                    };
                    if(res.passZoneResponseList.length>2){
                        row.stops = [];
                        for(let i = 1;i<res.passZoneResponseList.length-1;i++){
                            row.stops.push(
                            {
                                addrDetail:res.passZoneResponseList[i].addrDetail,
                                orderPlacerName:res.passZoneResponseList[i].contactName,
                                planArriveTm:this.formatTm(res.passZoneResponseList[i].planArriveTm),
                                orderPlacerPhone:res.passZoneResponseList[i].contactPhone,
                                planSendtm:this.formatTm(res.passZoneResponseList[i].planDepartTm),
                                sortNum:res.passZoneResponseList[i].sortNum,
                                jobType:res.passZoneResponseList[i].jobType,
                                coordinate:res.passZoneResponseList[i].coordinate,
                                cityCode:res.passZoneResponseList[i].cityCode,
                                cityName:res.passZoneResponseList[i].cityName
                            }
                            );
                        }
                    }
                    window.sessionStorage.setItem('stopHandleOrderParams', JSON.stringify(row));
                    this.$router.push("/manage/Shipments");
                }).catch(e => {
                    if (e && e.succ !== 'ok' && e.msg) {
                        this.$message({
                            type: "error",
                            message: e.msg
                        });
                    }
                })
            }
        }
    },
    watch: { 

    },
    created() {
	    this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
    },
    mounted() {
        let week_feb = moment().day(2).format('YYYY-MM-DD')
        this.changeDate(week_feb)
        this.$nextTick(function(){
            this.form_w.planDepartTm = '2021-03-10'
        })
        this.getOrderList_w()  
        this.getOrderList()
    }
}